<template>
    <textarea 
    :value="txt.value" 
    :placeholder="txt.placeholder"
    v-on="realtimeTxt"
    ></textarea>
</template>
<script>
export default {
    name: 'Textarea',
    props: [
        'lang', 'txt'
    ],
    computed: {
        realtimeTxt: function () {
            const vm = this;
            return Object.assign({},
                this.$listeners, {
                    input: function (event) {
                       vm.$emit('realtime', event.target.value);
                    }
                }
            )
        }
    },
}
</script>
<style lang="scss" scoped>

</style>